module.exports = __webpack_public_path__ + "img/gray.dbb466cb.svg";